var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9001 9.82446V22.8017C21.9001 23.4946 21.3384 24.0563 20.6456 24.0563H9.35464C8.66182 24.0563 8.1001 23.4946 8.1001 22.8017V9.82446",
    stroke: "#cccccc",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8638 9.08009V5.94373H18.1365V9.08009",
    stroke: "#cccccc",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7819 9.08008H6.21826",
    stroke: "#cccccc",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4025 19.7919L15.0785 17.4693L12.7544 19.7919C12.6228 19.9254 12.4432 20.0005 12.2557 20.0005C12.0683 20.0005 11.8886 19.9254 11.757 19.7919C11.4823 19.5161 11.4823 19.0701 11.757 18.7943L14.0811 16.4717L11.757 14.1491C11.6234 14.0165 11.55 13.8388 11.55 13.6507C11.55 13.4626 11.6234 13.2849 11.757 13.1523C11.889 13.0195 12.0686 12.9448 12.2559 12.945C12.4432 12.9452 12.6227 13.0202 12.7544 13.1533L15.0785 15.4749L17.4025 13.1523C17.5341 13.0189 17.7137 12.9437 17.9012 12.9437C18.0887 12.9437 18.2683 13.0189 18.3999 13.1523C18.5335 13.2849 18.6069 13.4626 18.6069 13.6507C18.6069 13.8388 18.5335 14.0165 18.3999 14.1491L16.0758 16.4707L18.3999 18.7933C18.6009 18.9955 18.6608 19.2985 18.5518 19.5618C18.4429 19.8252 18.1864 19.9975 17.9012 19.9988C17.7139 19.9994 17.5343 19.9248 17.4025 19.7919Z",
    fill: "#cccccc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteDelete);
export default __webpack_public_path__ + "note-delete.3161570084c30957eafd03f1ec0c6b28.svg";
export { ForwardRef as ReactComponent };